import { DynamicTableWidgetDetailsM } from './../../../../modules/shared/models/dynamic-table/dynamic-table-widget-details.model';
import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { addInList } from 'src/app/modules/shared/helpers';
// RxJS
import { Subject } from 'rxjs';
import { catchError, debounceTime, map, takeUntil } from 'rxjs/operators';

// Components
import { AppMainComponent } from 'src/app/app.main.component';

// Models
import { AccountInventoryDetails, IAccountPaymentMethods } from '../models/accountInventoryDetails.model';

// Services
import { AccountService } from 'src/app/accounts/accountService';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { AppMainService } from 'src/app/app-main.service';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';

// Enums and Constants
import { Status, CreditControlEnum, CreditTypeEnum } from 'src/app/models/statusEnums';
import { DatePipe, DecimalPipe } from '@angular/common';
import { CurrencyService } from 'src/app/modules/shared/services/currency.service';
import { TabView } from "primeng/tabview";
import { SettingService } from 'src/app/configurations/inventory/setting/setting.service';
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { SharedDataService } from 'src/app/modules/shared/stores/sharedDataStore/sharedData.service';
import { UtilityService } from 'src/app/inventory/sales-order/utils/utility.service';
import { Fields } from '../../../../modules/shared/models/column-settings.model';
import { GelAllAccountRequestModel } from '../../../models/account-request.model';
import { AccountServiceN } from '../../../services/account.services';

@Component({
  selector: 'app-account-inventory-details',
  templateUrl: './account-inventory-details.component.html',
  styleUrls: ['./account-inventory-details.component.scss']
})
export class AccountInventoryDetailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedAccount: any;
  @Input() checkedFields: any;
  @Input() accountId: number;
  @Input() hasChildAccounts: boolean = false;
  @Input() savedDetailViewCols: Fields[] = [];
  @Input() tabList: DynamicTableWidgetDetailsM[] = [];
  @Input() isLeftTableHide: boolean = false;
  @Input() activeSubtabIndex: number = -1;
  @Output() deleteSubtab = new EventEmitter();
  @ViewChild(TabView) tabView: TabView;
  // @Input() displayAccountDetails: boolean;
  displayAccountDetails: boolean = false;
  //@Output() onAccountDetailClose = new EventEmitter();
  isPaymentTerm: boolean = false;
  isPaymentMethod: boolean = false;
  isShipping: boolean = false;
  isDisabled: boolean = false;
  // details
  shippingCol = [
    { id: 1, name: "Shipping Methods", data: '' },
    { id: 2, name: "Default Shipping Method", data: '' },
    { id: 3, name: "Shipping Terms", data: '' },
    { id: 4, name: "FOB Point", data: '' },
  ];
  paymentsCol = [
    { id: 1, name: "Payment Methods", data: '' },
    { id: 2, name: "Default Payment Method", data: '' },
    { id: 3, name: "Payment Terms", data: '' },
    { id: 4, name: "Credit Limit", data: '' },
    { id: 5, name: "Available Credit", data: '' },
  ];
  displayTierList = false;
  allTiers = [];
  selectedTier;
  selectedTiers = []
  displayGroupList = false;
  selectedGroups = [];
  tiersForGroup = [];
  items = [];
  tiersDD = [
    { id: 1, name: "Gold" }
  ];
  displayItemList = false;
  selectedItems = [];
  noProductsFindOrLoadingText: string = 'Loading';
  productDataAll = [];
  productData = [];
  totalRecords: number = 0;
  pageNumber: number = 1;
  first: number = 0;
  pageSize: number = 15;
  searchValue: string = '';
  modelChanged = new Subject<string>();
  isEdit = false;
  productChannels = [];
  selectedTBChannel;
  priceTierByAccount: any;
  accountPriceTiers = [];
  accountPriceGroups = [];
  priceTierConfig = [];
  discountTypeId;
  selectedLocation;
  paymentTerms = [];
  paymentTermsDD = [];
  paymentMethods = [];
  paymentMethodsDD = [];
  shippingTerms = [];
  shippingTermsDD = [];
  shippingMethods = [];
  shippingMethodsDD: any[] = [];
  defaultShippingMethodsOptions: any[] = [];
  shipMethods = [];
  fobPoints = [];
  wareHouseList = [];
  inventoryForm: FormGroup;
  accountPaymethodForm: FormGroup;
  savedInventoryDetails: AccountInventoryDetails;
  accountLevelCreditAvail: boolean = false;
  accountPaymentMethodLists: IAccountPaymentMethods[];
  childAccountRelations = [];
  payDetailId: number = 0;
  displayRelationship: boolean = false;
  hasAccessAll: boolean = false;
  groupList = [];
  category = [];
  selectedCategory;
  invActiveIndex: number = 0;
  showAddButton: boolean = false;
  allMethodTypes: any[];
  priceBookEnabled: boolean = false;
  selectedPM;
  displayAddPaymentMethod = false;
  selectedSM;
  displayAddShippingMethod = false;
  pricingItems: MenuItem[];
  terms = [];
  //credit
  creditControlStatic = CreditControlEnum;
  creditTypeStatic = CreditTypeEnum;
  creditOptions = [
    { name: 'On', code: this.creditControlStatic.On },
    { name: 'Off', code: this.creditControlStatic.Off },
    { name: 'Hold', code: this.creditControlStatic.Hold }
  ];
  credits = [
    {
      id: 1, name: "Credit Limit", value: 0, children: [
        { id: 1, name: "Available Credit", value: 0 },
        { id: 2, name: "Used Credit", value: 0 },
      ]
    },
  ];
  currencySymbol = "";
  displayCreditLimit = false;
  creditForm: FormGroup;
  creditSetting: boolean = false;
  /* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();
  //address
  addressInput: string = '';
  formattedAddress: string = '';
  ErrorMessageSetLocation = '';
  states = [];
  city = [];
  country = [];
  addFlag: boolean = true;
  savedAccountPayMethodDetails: any;
  minYear;
  selectedTabHeader: string = '';
  accountModuleId = AccountModuleId;
  contactListAttn: any[] = [];
  countries: any[] = [];
  addressTypes: any[] = [];
  addressClasses: any[] = [];
  overViewPage: boolean = false;

  //Sub Accounts
  phoneFields: string[] = ['workphone', 'contactphonemobile', 'contactphonework', 'contactphonehome', 'contactphonecp1', 'contactphonecp2'];
  childAccounts: any[] = [];
  selectedChildAccount: any = null;
  totalChildRecords: number = 0;
  displayAccountViewEdit: boolean = false;
  selectedAccountId: number = 0;

  constructor(
    private fb: FormBuilder, private decimalPipe: DecimalPipe,
    private app: AppMainComponent,
    private accountService: AccountService,
    private productsService: ProductsService,
    private storeService: StoreService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private appMainService: AppMainService,
    private currencyService: CurrencyService,
    private settingService: SettingService,
    private sharedDataService: SharedDataService,
    private accountServiceN: AccountServiceN,
    private utilityService: UtilityService
  ) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe(() => {
        this.onSearch();
      })
  }

  ngOnInit(): void {
    this.invActiveIndex = 0;
    this.showAddButton = false;
    // this.loadCountries();
    // this.loadAddressTypes();
    // this.loadAccountAddressClass();
    // this.sharedDataService.dispatchGettingCountriesList();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.accountId?.currentValue) {
      this.accountId = changes?.accountId?.currentValue;
      this.getAllInventoryDataFromStore();
      this.getAllInventoryDataFromAPI();
      this.prepareInventoryForm();
      this.preparePayMethodForm();
      this.prepareCreditForm();
      // this.loadShippingMethods();
      // this.loadShippingTerms();
      // this.loadFOBPoints();
      // this.loadPaymentMethods();
      // this.loadPaymentTerms();
      this.pricingItems = [
        {
          label: 'Price Tier',
          command: () => { this.showTierList(); }
        },
        {
          label: 'Group Discounts',
          command: () => { this.showGroupList(); }
        },
        {
          label: 'Item Pricing',
          command: () => { this.showItemList(); }
        },
      ];
      this.currencySymbol = this.currencyService.currencySymbolValue;
    }

    if (changes?.selectedAccount && changes?.selectedAccount?.currentValue) {
      this.selectedAccount = changes?.selectedAccount?.currentValue;
      this.contactListAttn = this.selectedAccount.accountContacts?.filter(
        (el) => el.contact
      );
    }

    if (changes?.checkedFields && changes?.checkedFields?.currentValue) {
      this.checkedFields = changes?.checkedFields?.currentValue;
    }

    if (changes?.savedDetailViewCols && changes?.savedDetailViewCols?.currentValue) {
      this.savedDetailViewCols = changes.savedDetailViewCols.currentValue;

      if (this.selectedTabHeader == 'Sub Accounts') {
        this.loadChildAccounts();
      }
    }
  }

  getAllInventoryDataFromAPI(): void {
    this.loadInventoryDetails(this.accountId, true);
    // this.loadPriceBookDetails(this.accountId);
    this.loadAllPriceTierGroup();
    // this.loadAllWareHouses();
    // this.loadInventoryGroups();
    this.loadISettings();
  }

  loadISettings() {
    this.settingService.getAllInventorySettings().subscribe(settings => {
    this.creditSetting = settings?.find(set => set.code.toLowerCase() === 'acccredit')?.enabled;
    })
  }

  prepareInventoryForm(): void {
    this.inventoryForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      paymentTerms: [''],
      preferredPaymentTerm: [''],
      paymentMethods: [''],
      preferredPaymentMethod: [''],
      shippingMethods: [''],
      preferredShippingMethod: [''],
      shippingTerms: [''],
      preferredShippingTerm: [''],
      availableCredit: [0],
      creditLimit: [0],
      fobPoint: ['']
    });

    this.inventoryForm?.controls['creditLimit'].setValue(this.savedInventoryDetails?.creditLimit);
    this.inventoryForm?.controls['availableCredit'].setValue(this.savedInventoryDetails?.availableCredit);
  }

  getAllInventoryDataFromStore(): void {
    this.storeService.getInventoryDetails().subscribe(data => {
      this.savedInventoryDetails = data;
      this.inventoryForm?.controls['creditLimit'].setValue(this.savedInventoryDetails?.creditLimit);
      this.inventoryForm?.controls['availableCredit'].setValue(this.savedInventoryDetails?.availableCredit);
      data && this.setShippingPaymentDetails(data);
      if(data?.accountId!=this.accountId){
        this.savedInventoryDetails =  null;
      }
    });

    this.storeService.getPriceTierByAccount().subscribe(data => {
      this.priceTierByAccount = data;
      this.processPriceBookDetailsData(data);
    });

    this.storeService.getPriceTierConfiguration().subscribe(data => this.priceTierConfig = data);

    this.storeService.getAllWarehouseList().subscribe(data => {
      this.wareHouseList = data;
      this.setSelectedLocation();
    });

    this.storeService.getGroupList().subscribe(data => this.groupList = data);

    this.storeService.getCategoryHierarchyList().subscribe(data => this.category = data);

    // Inventory Form DD Value
    this.storeService.getShippingMethods().subscribe(data => { this.shippingMethods = data; });
    this.storeService.getShippingTerms().subscribe(data => { this.shippingTerms = data; });
    this.storeService.getFOBPoints().subscribe(data => { this.fobPoints = data; });
    this.storeService.getPaymentMethods().subscribe(data => { this.paymentMethods = data; });
    this.storeService.getPaymentTerms().subscribe(data => { this.paymentTerms = data; });
  }

  //Inventory Pricebook
  loadAllPriceTierGroup() {
    // !this.priceTierConfig.length &&
    this.accountService.getPriceTierList()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.priceBookEnabled = data.item1;
        if (data.item1) {
          this.priceTierConfig = data.item2 || [];
          this.storeService.setPriceTierConfiguration(this.priceTierConfig);
        }
      })
  }

  displayAddButton() {
    this.showAddButton = true;
  }

  showTierList() {
    this.selectedTier = null;
    const tiers = this.priceTierConfig?.filter(item => item.name == 'Discount By Qty').map(tier => tier.childPriceTier)[0];
    this.allTiers = tiers?.filter(t => t.isVisible == true && t.isCustom == false && t.statusId == Status.Active);
    this.displayTierList = true;
  }

  editTierList(tier) {
    this.selectedTier = null;
    const tiers = this.priceTierConfig?.filter(item => item.name == 'Discount By Qty').map(tier => tier.childPriceTier)[0];
    this.allTiers = tiers?.filter(t => t.isVisible == true && t.isCustom == false && t.statusId == Status.Active);
    this.selectedTier = this.allTiers?.filter(t => t.id == tier.tierId)[0];
    this.displayTierList = true;
  }

  removeTier(id, i, type) {
    this.confirmationService.confirm({
      message: `Do you want to remove this ${type}?`,
      header: "Remove Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        this.accountService
          .deleteTier(id)
          .then(() => {
            if (type == 'tier') {
              this.accountPriceTiers.splice(i, 1);
            } else if (type == 'group') {
              this.accountPriceGroups.splice(i, 1);
            } else {
              this.items.splice(i, 1);
            }
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: "Deleted Successfully...",
            });
          })
          .catch(() => {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Error occurred while deleting data...",
            });
          });
      },
      reject: () => { },
    });
  }

  setAccountTierGroupData(data, type) {
    const reqData = [];
    data.forEach(element => {
      const dataEach = {
        id: (type == 'tier' ? (this.accountPriceTiers?.filter(t => t.tierId == element.id)[0] ? this.accountPriceTiers?.filter(t => t.tierId == element.id).map(tier => tier.id)[0] : 0) :
          type == 'group' ? (this.accountPriceGroups?.filter(t => t.tierId == element.id)[0] ? (this.accountPriceGroups?.filter(t => t.tierId == element.id).map(tier => tier.id)[0]) : 0) :
            (this.items?.filter(i => i.productId == element.id)[0] ? (this.items?.filter(i => i.productId == element.id).map(item => item.id)[0]) : 0)),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        accountId: this.accountId,
        tierId: (type == 'customPrice' ? element.selectedTier?.id : element.id),
        productPriceTierId: 0,
        productId: (type == 'customPrice' ? element.id : 0),
        price: (type == 'customPrice' ? element.price : 0),
        typeId: (type == 'customPrice' ? this.discountTypeId : element.typeId),
        statusId: 1,
        warehouseId: (type == 'customPrice' ? this.selectedLocation?.id : 0),
        calculatedPricePerQty: 0
      }
      reqData.push(dataEach);
    });
    return reqData;
  }

  saveTier(type) {
    this.isDisabled = true;
    this.selectedTiers = [];
    this.selectedTiers.push(this.selectedTier);
    const req = this.setAccountTierGroupData(type == 'tier' ? this.selectedTiers : type == 'group' ? this.selectedGroups : this.selectedItems, type);
    if (type == 'customPrice') {
      const res = this.items?.filter(x => !this.selectedItems?.some(y => y.id == x.productId));
      if (res?.length) {
        res.forEach(el => {
          req.push(el);
        });
      }
    }
    this.updateAccountTierData(req);
  }

  updateAccountTierData(req) {
    this.accountService
      .updateAccountPriceTier(req)
      .then(() => {
        this.priceTierByAccount = null;
        this.loadPriceBookDetails(this.accountId);
        this.displayTierList = false;
        this.displayGroupList = false;
        this.displayItemList = false;
        this.showAddButton = false;
        this.isEdit = false;
        this.isDisabled = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Updated Successfully...",
        });
      })
      .catch(() => {
        this.isDisabled = false;
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error occurred while updating data...",
        });
      });
  }

  showGroupList() {
    this.selectedGroups = [];
    const tiersForGroup = this.priceTierConfig?.filter(item => item.name == 'Discount By Product Group').map(tier =>
      tier.childPriceTier)[0];
    this.tiersForGroup = tiersForGroup?.filter(group => group.statusId == Status.Active);
    for (let grp of this.accountPriceGroups) {
      const group = this.tiersForGroup?.filter(g => g.id == grp.tierId)[0];
      if (group) {
        this.selectedGroups.push(group);
      }
    }
    this.displayGroupList = true;
  }

  showItemList() {
    this.selectedItems = [];
    this.first = 0;
    this.getProductsChannels('Product Type');
  }

  onChangeTier(item) {
    item.isChecked = true;
    item.price = item.selectedTier?.salesPrice;
    const exists = this.selectedItems?.filter((i: any) => i.id == item.id)[0];
    if (exists) {
      const index = this.selectedItems.indexOf(exists);
      this.selectedItems.splice(index, 1);
      this.selectedItems.push(item);
    } else {
      this.selectedItems.push(item);
    }
  }

  onChangePrice(item) {
    item.isChecked = true;
    const exists = this.selectedItems?.filter((i: any) => i.id == item.id)[0];
    if (exists) {
      const index = this.selectedItems.indexOf(exists);
      this.selectedItems.splice(index, 1);
      this.selectedItems.push(item);
    } else {
      this.selectedItems.push(item);
    }
  }

  loadAllWareHouses() {
    !this.wareHouseList.length &&
      this.accountService.getAllLocations()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((wHouse) => {
          wHouse = wHouse || [];
          for (let loc of wHouse) {
            loc.customName = loc.name + ' - ' + loc.locationId;
          }
          this.wareHouseList = wHouse.filter(wh => wh.statusId == 1) || [];
          this.storeService.setAllWarehouseList(this.wareHouseList);
          this.setSelectedLocation();
        });
  }

  setSelectedLocation() {
    this.selectedLocation = this.wareHouseList?.filter(wh => wh.isDefault)[0];
  }

  loadInventoryGroups() {
    !this.groupList.length &&
      this.accountService.getInventoryGroupList()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(groups => {
          this.groupList = groups || [];
          this.storeService.setGroupList(this.groupList);
          const productInventoryGroup = groups.filter(s => s.name == 'Product Category')[0];
          this.getInventoryCategory(productInventoryGroup.id);
        });
  }

  getInventoryCategory(groupId) {
    !this.category.length &&
      this.accountService.getInventoryCategoryList(groupId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(cats => {
          if (cats) {
            this.category = cats.filter(cat => cat.statusId == 1) || [];
            this.storeService.setCategoryHierarchyList(this.category);
          }
        });
  }

  changed(event) {
    this.modelChanged.next("");
  }

  productByCate() {
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.searchValue = '';
    this.loadProducts(this.pageNumber, this.pageSize, this.selectedTBChannel.id, this.discountTypeId, this.selectedCategory?.id,
      this.selectedLocation?.id, this.searchValue);
  }

  onSearch() {
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.loadProducts(this.pageNumber, this.pageSize, this.selectedTBChannel.id, this.discountTypeId, this.selectedCategory?.id,
      this.selectedLocation?.id, this.searchValue);
  }

  onTypeChange() {
    this.first = 0;
    this.pageNumber = 1;
    this.pageSize = 15;
    this.selectedCategory = null;
    this.loadProducts(this.pageNumber, this.pageSize, this.selectedTBChannel.id, this.discountTypeId, null,
      this.selectedLocation?.id, '');
  }

  getData(event) {
    this.pageNumber = (event.first / event.rows) + 1;
    this.first = event.first;
    this.loadProducts(this.pageNumber, this.pageSize, this.selectedTBChannel.id, this.discountTypeId, this.selectedCategory?.id,
      this.selectedLocation?.id, this.searchValue);
  }

  getProductsChannels(name) {
    this.discountTypeId = this.priceTierConfig?.filter(item => item.name == 'Discount By Qty').map(type => type.id)[0];
    this.productsService.getAllProductChannel(name)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(channels => {
        const config = JSON.parse(channels.configurationDetails[0].configJSONValue);
        this.productChannels = config.filter((el) => !['Bundle Item'].includes(el.name));
        this.selectedTBChannel = this.productChannels[0];
        this.pageNumber = 1;
        this.pageSize = 15;
        this.loadProducts(this.pageNumber, this.pageSize, this.selectedTBChannel?.id, this.discountTypeId, null,
          this.selectedLocation?.id, null);
      });
  }

  setTier(tierId, allTier) {
    const tier = allTier?.filter(tier => tier.id == tierId)[0];
    return tier;
  }

  loadProducts(pageNumber, pageSize, typeId, discountTypeId, categoryId, warehouseId, searchValue) {
    this.appMainService.isShowSpinner('tier');
    this.accountService.getAllItems(pageNumber, pageSize, typeId, discountTypeId, categoryId, warehouseId, searchValue)
      .then(products => {
        let { items, headers } = products;
        items = items == null ? [] : items;
        headers = headers == null ? [] : headers;
        this.totalRecords = headers['TotalCount'];
        this.productDataAll = [];
        this.productData = [];
        if (items?.length) {
          for (let l of items) {
            const eachItem = {
              id: l.productId,
              itemNo: l.itemNo,
              description: l.itemDescription,
              cost: parseFloat(l.costPrice).toFixed(2),
              price: parseFloat(l.salesPrice).toFixed(2),
              customTiers: l.priceTier,
              selectedTier: this.setTier(this.items?.filter(item => item.productId == l.productId).map(item => item.tierId)[0], l.priceTier),
              isChecked: (this.items?.filter(item => item.productId == l.productId)[0] ? true : false)
            }
            this.productDataAll.push(eachItem);
          }
          this.productData = JSON.parse(JSON.stringify(this.productDataAll));
          this.productData.forEach((element: any) => {
            const alreadyChecked: any = this.selectedItems?.filter((item: any) => item.id == element.id)[0];
            if (alreadyChecked) {
              element.isChecked = true;
              element.selectedTier = alreadyChecked.selectedTier;
            }
          });
          this.appMainService.isHideSpinner('tier');
          this.displayItemList = true;
        } else {
          this.totalRecords = 0;
          this.appMainService.isHideSpinner('tier');
          this.noProductsFindOrLoadingText = 'No Products found.';
        }
      });
  }

  loadInventoryDetails(accountId, type?) {
    !this.savedInventoryDetails &&
      this.accountService.getAllInventoryDetails(accountId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.savedInventoryDetails = data;
          this.accountLevelCreditAvail = this.savedInventoryDetails.accountCreditEnabled;
          this.storeService.setInventoryDetails(data);
          this.processPaymentMethods();
          this.processPaymentTerms(this.paymentTerms);
          this.processShippingMethods(this.shippingMethods);
          this.processShippingTerms(this.shippingTerms);
          this.setShippingPaymentDetails(data);
          this.setCreditData();
          if (type) {
            this.onTabChange(null)
          }
        })
  }

  setShippingPaymentDetails(data: AccountInventoryDetails): void {
    // Set Shipping Details
    this.shippingCol[0].data = data.shippingMethods;
    this.shippingCol[1].data = data.defaultShippingMethod;
    this.shipMethods = data.shippingMethodsList;
    this.shippingCol[2].data = data.shippingTerms;
    this.shippingCol[3].data = data.fobPoint;

    // Set Payment Details
    this.paymentsCol[0].data = data.paymentMethods;
    this.paymentsCol[1].data = data.defaultPaymentMethod;
    this.paymentsCol[2].data = data.paymentTerms;
    this.paymentsCol[3].data = this.decimalPipe.transform(data.creditLimit, '1.2-2');
    this.paymentsCol[4].data = this.decimalPipe.transform(data.availableCredit, '1.2-2');
    this.terms = data.paymentTermsList;
  }

  loadPriceBookDetails(accountId) {
    !this.priceTierByAccount &&
      this.accountService.getAllPriceBookDetails(accountId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.priceTierByAccount = data;
          this.processPriceBookDetailsData(data);
          this.storeService.setPriceTierByAccount(this.priceTierByAccount);
        });
  }

  processPriceBookDetailsData(data: any): void {
    this.accountPriceTiers = data?.filter(d => d.name == 'Discount By Qty').map(tier => tier.childAccountProductPriceTier)[0];
    this.accountPriceGroups = data?.filter(d => d.name == 'Discount By Product Group').map(tier => tier.childAccountProductPriceTier)[0];
    this.items = data?.filter(d => d.name == 'Custom').map(tier => tier.childAccountProductPriceTier)[0];
  }

  loadShippingMethods() {
    if (this.shippingMethods?.length) {
      //this.processShippingMethods(this.shippingMethods);
    } else {
      this.accountService.getShippingMethodList()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          for (let dt of data) {
            dt.inactive = (dt.statusId == Status.Active ? false : true);
          }
          this.shippingMethods = data || [];
          this.storeService.setShippingMethods(this.shippingMethods);
          this.processShippingMethods(data);
        });
    };
  }

  processShippingMethods(data: any[]): void {
    this.defaultShippingMethodsOptions = [];
    this.shippingMethodsDD = data?.filter(method => method.statusId == Status.Active);
    const treeStructureShippingMethodsDD: any = this.utilityService.prepareShippingMethods(this.shippingMethodsDD);
    this.shippingMethodsDD = treeStructureShippingMethodsDD;
    // edit
    const defaultShippingMethods = [];
    // to manage shipping method dropdown on edit
    this.savedInventoryDetails?.shippingMethodsList.forEach(list => {
      const parent = this.shippingMethodsDD?.find(ac => ac.id === list?.shippingMethodID || (0 === list?.shippingMethod?.parentShippingMethodId && ac.id === list?.shippingMethod?.id));
      if (parent) {
        parent.isDefault = list.isDefault;
        defaultShippingMethods.push(parent);
      }
      this.shippingMethodsDD.forEach(ac => {
        const childAccount = ac.children?.find(
          (child) => child.value?.id == list.shippingMethodId
        );
        if (childAccount) {
          childAccount.isDefault = list.isDefault;
          defaultShippingMethods.push(childAccount);
        }
      });
    });

    this.inventoryForm?.controls['shippingMethods'].setValue(defaultShippingMethods);

    // to manage default shipping method dropdown on edit
    let childrenParent: any;
    defaultShippingMethods.forEach(data => {
      if (data.value.parentShippingMethodId === 0) {
        childrenParent = this.shippingMethodsDD?.find(method => method?.id == data.id);
      } else {
        childrenParent = this.shippingMethodsDD?.find(method => method?.id == data.value.parentShippingMethodId || 0 === data?.value?.parentShippingMethodId);
      }
      let reStructure: any;
      let parentCopy: any = {};
      parentCopy = {
        ...childrenParent
      }

      if (childrenParent && childrenParent != undefined) {
        reStructure = parentCopy.children.filter(id => id.id === data?.id);
        parentCopy.children = reStructure;

      }
      if (childrenParent != undefined) {
        let itemExists = this.defaultShippingMethodsOptions?.find(item => item?.id == parentCopy?.id);
        if (itemExists) {
          itemExists.children.push(reStructure[0]);
        } else if (parentCopy != undefined) {

          this.defaultShippingMethodsOptions.push(parentCopy);
        }

      }

    })

    // //Set Preferred
    const preferred = defaultShippingMethods?.filter(term => term.isDefault == true)[0];
    this.inventoryForm?.controls['preferredShippingMethod'].setValue(preferred);

  }

  onShippingMethodSelected(event: any): void {
    if (event.node.parent === undefined) {
      this.defaultShippingMethodsOptions.push(event.node);
    } else {
      const parent = event.node.parent;
      let parentCopy: any = {};
      parentCopy = {
        ...parent
      }
      const reStructure = parent.children.filter(id => id.id === event.node?.id);
      parentCopy.children = reStructure;
      let itemExists = this.defaultShippingMethodsOptions?.find(item => item?.id == parentCopy?.id);
      if (itemExists) {
        itemExists.children.push(reStructure[0]);
      } else {
        this.defaultShippingMethodsOptions.push(parentCopy);
      }

    }

  }

  onShippingMethodUnselected(event: any) {
    if (event.node.parent === undefined) {
      this.defaultShippingMethodsOptions = this.defaultShippingMethodsOptions.filter(node => node.id !== event.node?.id);
    } else {
      this.defaultShippingMethodsOptions.forEach(data => {
        data.children = data.children.filter(node => node.id !== event.node?.id);
      })
    }
  }



  loadShippingTerms() {
    if (this.shippingTerms?.length) {
      //this.processShippingTerms(this.shippingTerms);
    } else {
      this.accountService.getShippingTermList()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          for (let dt of data) {
            dt.inative = (dt.statusId == Status.Active ? false : true);
          }
          this.shippingTerms = data || [];
          this.storeService.setShippingTerms(this.shippingTerms);
          this.processShippingTerms(data);
        });
    }
  }

  processShippingTerms(data: any[]): void {
    this.shippingTermsDD = data?.filter(dt => dt.statusId == Status.Active);
    //Check for Inactive Shipping Term records
    const res = this.savedInventoryDetails?.shippingTermsList?.filter(x => !this.shippingTermsDD?.some(y => y.id ==
      x.shippingTermId));
    if (res?.length > 0) {
      res.forEach(element => {
        this.shippingTermsDD.push(element.shippingTerm);
      });
    }
    const defaultShippingTerms = [];
    this.savedInventoryDetails?.shippingTermsList?.forEach(element => {
      const filteredShippingTerms = this.shippingTerms?.filter(term => term.id == element.shippingTermId)[0];
      if (filteredShippingTerms) {
        filteredShippingTerms.isDefault = element.isDefault;
        defaultShippingTerms.push(filteredShippingTerms);
      }
    });

    this.inventoryForm?.controls['shippingTerms'].setValue(defaultShippingTerms);
    //Set Preferred
    const preferred = defaultShippingTerms?.filter(term => term.isDefault == true)[0];
    this.inventoryForm?.controls['preferredShippingTerm'].setValue(preferred);
  }

  loadFOBPoints() {
    if (this.fobPoints.length) {
      this.processFOBPoints();
    } else {
      this.accountService.getFOBList()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.fobPoints = data || [];
          this.storeService.setFOBPoints(this.fobPoints);
          this.processFOBPoints();
        });
    }
  }

  processFOBPoints() {
    const filteredFOB = this.fobPoints?.filter(point => point.id == this.savedInventoryDetails?.fobPoint)[0];
    this.inventoryForm?.controls['fobPoint'].setValue(filteredFOB);
  }

  loadPaymentMethods() {
    if (this.paymentMethods?.length) {
      //this.processPaymentMethods();
    } else {
      this.accountService.getPaymentMethodList()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          for (let dt of data) {
            dt.inactive = (dt.statusId == Status.Active ? false : true);
          }
          this.paymentMethods = data || [];
          this.storeService.setPaymentMethods(this.paymentMethods);
          this.processPaymentMethods();
        });
    }
  }

  processPaymentMethods(): void {
    this.paymentMethodsDD = this.paymentMethods?.filter(method => method.statusId == Status.Active);
    //Check for Inactive Payment Method records
    const res = this.savedInventoryDetails?.paymentMethodsList?.filter(x => !this.paymentMethodsDD?.some(y => y.id ==
      x.paymentMethodId));
    if (res?.length) {
      res.forEach(element => {
        this.paymentMethodsDD.push(element.paymentMethod);
      });
    }
    const defaultPaymentMethods = [];
    this.savedInventoryDetails?.paymentMethodsList?.forEach(element => {
      const filteredPaymentMethods = this.paymentMethods?.filter(method => method.id == element.paymentMethodId)[0];
      if (filteredPaymentMethods) {
        filteredPaymentMethods.isDefault = element.isDefault;
        defaultPaymentMethods.push(filteredPaymentMethods);
      }
    });
    this.inventoryForm?.controls['paymentMethods'].setValue(defaultPaymentMethods);
    //Set Preferred
    const preferred = defaultPaymentMethods?.filter(term => term.isDefault == true)[0];
    this.inventoryForm?.controls['preferredPaymentMethod'].setValue(preferred);
  }

  loadPaymentTerms() {
    if (this.paymentTerms?.length) {
      // this.processPaymentTerms(this.paymentTerms);
    } else {
      this.accountService.getPaymentTermList()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          for (let dt of data) {
            dt.inactive = (dt.statusId == Status.Active ? false : true);
          }
          this.paymentTerms = data || [];
          this.storeService.setPaymentTerms(this.paymentTerms);
          this.processPaymentTerms(data);
        });
    }
  }

  processPaymentTerms(data: any[]) {
    this.paymentTermsDD = data?.filter(dt => dt.statusId == Status.Active);
    //Check for Inactive Payment Term records
    const res = this.savedInventoryDetails?.paymentTermsList?.filter(x => !this.paymentTermsDD?.some(y => y.id == x.paymentTermId));
    if (res?.length > 0) {
      res.forEach(element => {
        this.paymentTermsDD.push(element.paymentTerm);
      });
    }
    const defaultPaymentTerm = [];
    this.savedInventoryDetails?.paymentTermsList?.forEach(element => {
      const filteredPaymentTerms = this.paymentTerms?.filter(term => term.id == element.paymentTermId)[0];
      if (filteredPaymentTerms) {
        filteredPaymentTerms.isDefault = element.isDefault;
        defaultPaymentTerm.push(filteredPaymentTerms);
      }
    });
    this.inventoryForm?.controls['paymentTerms'].setValue(defaultPaymentTerm);
    //Set Preferred
    const preferred = defaultPaymentTerm?.filter(term => term.isDefault)[0];
    this.inventoryForm?.controls['preferredPaymentTerm'].setValue(preferred);
  }

  setPaymentTerm(value) {
    const paymentTerms = [];
    value.paymentTerms?.forEach(element => {
      const termEach = {
        accountId: this.accountId,
        paymentTermId: element.id,
        id: (this.savedInventoryDetails?.paymentTermsList?.filter(term => term.paymentTermId == element.id) ?
          (this.savedInventoryDetails?.paymentTermsList?.filter(term => term.paymentTermId == element.id).map(t => t.id)[0]) : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        statusId: 1,
        isDefault: (value.preferredPaymentTerm?.id == element.id ? true : false),
        paymentTermName: element.name
      }
      paymentTerms.push(termEach);
    });
    return paymentTerms;
  }

  setPaymentMethod(value) {
    const paymentMethods = [];
    value.paymentMethods?.forEach(element => {
      const termEach = {
        accountId: this.accountId,
        paymentMethodId: element.id,
        id: (this.savedInventoryDetails?.paymentMethodsList?.filter(term => term.paymentMethodId == element.id) ?
          (this.savedInventoryDetails?.paymentMethodsList?.filter(term => term.paymentMethodId == element.id).map(t => t.id)[0]) : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        statusId: 1,
        isDefault: (value.preferredPaymentMethod?.id == element.id ? true : false),
        paymentMethodName: element.name
      }
      paymentMethods.push(termEach);
    });
    return paymentMethods;
  }

  setShippingMethod(value) {
    const shippingMethods = [];
    value.shippingMethods?.forEach(element => {
      const termEach = {
        accountId: this.accountId,
        shippingMethodId: element.id,
        id: (this.savedInventoryDetails?.shippingMethodsList?.filter(term => term.shippingMethodId == element.id)[0] ?
          (this.savedInventoryDetails?.shippingMethodsList?.filter(term => term.shippingMethodId == element.id).map(t => t.id)[0]) : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        statusId: 1,
        isDefault: (value.preferredShippingMethod?.id == element.id ? true : false),
        shippingMethodName: element.name
      }
      shippingMethods.push(termEach);
    });
    return shippingMethods;
  }

  setShippingTerm(value) {
    const shippingTerms = [];
    value.shippingTerms?.forEach(element => {
      const termEach = {
        accountId: this.accountId,
        shippingTermId: element.id,
        id: (this.savedInventoryDetails?.shippingTermsList?.filter(term => term.shippingTermId == element.id)[0] ?
          (this.savedInventoryDetails?.shippingTermsList?.filter(term => term.shippingTermId == element.id).map(t => t.id)[0]) : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        statusId: 1,
        isDefault: (value.preferredShippingTerm?.id == element.id ? true : false),
        shippingTermName: element.name
      }
      shippingTerms.push(termEach);
    });
    return shippingTerms;
  }

  calculateAvailCredit(value) {
    if (this.savedInventoryDetails?.creditLimit > value.creditLimit) {
      const diff = (Number(this.savedInventoryDetails?.creditLimit) - Number(value.creditLimit));
      const availCredit = (Number(this.savedInventoryDetails.availableCredit) - Number(diff));
      return availCredit;
    } else if (value.creditLimit > this.savedInventoryDetails?.creditLimit) {
      const diff = (Number(value.creditLimit) - Number(this.savedInventoryDetails?.creditLimit));
      const availCredit = (Number(this.savedInventoryDetails.availableCredit) + diff)
      return availCredit
    } else {
      return value.availableCredit
    }
  }

  saveInventoryDetails(value) {
    const availCredit = this.calculateAvailCredit(value);
    const req = {
      accountPaymentTerms: this.setPaymentTerm(value),
      accountPaymentMethods: this.setPaymentMethod(value),
      accountShippingMethods: this.setShippingMethod(value),
      accountShippingTerms: this.setShippingTerm(value),
      creditLimit: value.creditLimit,
      availableCredit: availCredit,
      accountId: this.accountId
    };
    this.accountService
      .updateAccountInventoryDetails(req)
      .then(() => {
        this.savedInventoryDetails = null;
        //this.onTabChange(null);
        this.loadInventoryDetails(this.accountId);
        this.getAccountPaymentMethods();
        this.getAllCountry();
        this.displayAccountDetails = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Updated Successfully...",
        });
      })
      .catch(() => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error occurred while updating data...",
        });
      });
  }

  showAddPMPopup() {
    this.addFlag = true;
    this.minYear = this.app._showDateTimeWithZone(new Date());
    this.savedAccountPayMethodDetails = null;
    this.preparePayMethodForm();
    this.displayAddPaymentMethod = true;
  }

  async editPayMethod(value) {
    this.addFlag = false;
    this.savedAccountPayMethodDetails = value;
    this.accountPaymethodForm.patchValue(value);
    const filteredPayMethod = this.inventoryForm?.controls['paymentMethods'].value?.find(pay => pay.id == value.paymentMethodId);
    this.accountPaymethodForm.controls['paymentMethodId'].setValue(filteredPayMethod);
    this.accountPaymethodForm.controls['expirationDate'].setValue(this.app._showDateTimeWithZone(value.expirationDate));
    this.accountPaymethodForm.controls['accountNo'].setValue(value.accountKey);
    this.accountPaymethodForm.controls['routingNo'].setValue(value.routingKey);
    this.accountPaymethodForm.controls['statusId'].setValue(value.statusId == 1 ? true : false);
    if (value.countryId) {
      await this.getAsyncStatesFromCountry(value.countryId);
    }
    if (value.stateId) {
      await this.getAsyncCitiesFromState(value.stateId);
    }
    this.addressInput = value?.streetAddress1;
    const filteredCountry = this.country?.filter(c => c.id == value?.countryId)[0];
    this.accountPaymethodForm.controls['countryId'].setValue(filteredCountry);
    const filteredState = this.states?.filter(c => c.id == value?.stateId)[0];
    this.accountPaymethodForm.controls['stateId'].setValue(filteredState);
    const filteredCity = this.city?.filter(c => c.id == value?.cityId)[0];
    this.accountPaymethodForm.controls['cityId'].setValue(filteredCity);
    this.displayAddPaymentMethod = true
  }

  savePaymentMethod(value) {
    if (this.addFlag) {
      value.accountKey = value.accountNo;
      value.routingKey = value.routingNo;
      value.accountPaymentMethodId = this.savedInventoryDetails?.paymentMethodsList?.filter(pay => pay.paymentMethodId == value.paymentMethodId?.id).map(method => method.id)[0];
    } else {
      if (value.accountNo != this.savedAccountPayMethodDetails?.accountKey && value.routingNo != this.savedAccountPayMethodDetails?.routingKey) {
        value.accountKey = value.accountNo;
        value.routingKey = value.routingNo;
      } else if (value.accountNo != this.savedAccountPayMethodDetails?.accountKey) {
        value.accountKey = value.accountNo;
        value.routingNo = this.savedAccountPayMethodDetails?.routingNo;
      } else if (value.routingNo != this.savedAccountPayMethodDetails?.routingKey) {
        value.routingKey = value.routingNo;
        value.accountNo = this.savedAccountPayMethodDetails?.accountNo;
      } else {
        value.accountNo = this.savedAccountPayMethodDetails?.accountNo;
        value.routingNo = this.savedAccountPayMethodDetails?.routingNo;
      }
    }
    if (value.paymentMethodId?.type?.name == 'ACH' || value.paymentMethodId?.type?.name == 'Credit Card') {
      value.name = value.accountName;
    }
    value.streetAddress1 = this.addressInput;
    value.countryId = value.countryId?.id;
    value.stateId = value.stateId?.id;
    value.cityId = value.cityId?.id;
    value.paymentMethodId = value.paymentMethodId?.id;
    value.expirationDate = this.app._saveDateTimeWithZone(value.expirationDate);
    value.statusId = (value.statusId ? 1 : 2);
    if (this.addFlag) {
      this.accountService
        .addAccountPayMethod(value)
        .then(() => {
          this.getAccountPaymentMethods();
          this.displayAddPaymentMethod = false;
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Added Successfully...",
          });
        })
        .catch(() => {
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred while saving data...",
          });
        });
    } else {
      this.accountService.updateAccountPayMethod(value).then(() => {
        this.getAccountPaymentMethods();
        this.displayAddPaymentMethod = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Added Successfully...",
        });
      })
        .catch(() => {
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred while saving data...",
          });
        });
    }
  }

  makeDefault(method, list, type) {
    if (type == 'paymentmethod') {
      this.accountService.makeDefaultPayMethod(method.accountPaymentMethodId, method.id).pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          method.isDefault = true;
          list = this.setDefaultGeneric(method, list);
        })
    } else if (type == 'paymentterm') {
      this.accountService.makeDefaultPayTerm(this.accountId, method.id).pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          method.isDefault = true;
          list = this.setDefaultGeneric(method, list);
        })
    } else {
      this.accountService.makeDefaultShipMethod(this.accountId, method.id).pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          method.isDefault = true;
          list = this.setDefaultGeneric(method, list);
        })
    }
  }

  setDefaultGeneric(method, list) {
    for (let lst of list) {
      if (lst.id != method.id) {
        lst.isDefault = false;
      }
    }
    return list;
  }

  showAddSMPopup() {
    this.displayAddShippingMethod = true;
  }

  //credit
  changeCreditTye(action, creditType) {
    let msg;
    if (creditType == 'Consolidated') {
      msg = `Changing the type to <strong>Parent & Child</strong> will change the credit limit of child accounts accordingly.`
    } else {
      msg = `Changing the type to <strong>Parent only</strong>, the child will retain the parent Credit.`
    }
    this.confirmationService.confirm({
      message: `Do you want to change the Account Credit type?<br>
      Note - ${msg}`,
      header: "Change Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        this.editCredit(action)
      },
      reject: () => {
        this.creditForm.controls['creditTypeId'].setValue(this.savedInventoryDetails.creditTypeId);
      }
    });
  }


  editCredit(action?) {
    this.creditForm.controls['dailyMax'].setValue(this.savedInventoryDetails?.dailyMax);
    this.creditForm.controls['weeklyMax'].setValue(this.savedInventoryDetails?.weeklyMax);
    this.creditForm.controls['monthlyMax'].setValue(this.savedInventoryDetails?.monthlyMax);
    this.creditForm.controls['creditLimit'].setValue(this.savedInventoryDetails?.creditLimit);
    this.creditForm.controls['accountCreditEnabled'].setValue(this.savedInventoryDetails?.accountCreditEnabled);
    if (action) {
      this.creditForm.controls['accountCreditEnabled'].setValue(this.accountLevelCreditAvail);
      this.saveCreditData(this.creditForm.value);
    } else {
      this.displayCreditLimit = true;
    }
  }

  saveCreditData(value) {
    this.appMainService.isShowSpinner('edit');
    value.creditLimit = (value.creditLimit ?? 0);
    value.dailyMax = (value.dailyMax ?? 0);
    value.monthlyMax = (value.monthlyMax ?? 0);
    value.weeklyMax = (value.weeklyMax ?? 0);
    this.accountService.updateAccountCreditData(this.accountId, value).then(() => {
      this.displayCreditLimit = false;
      this.savedInventoryDetails = null;
      this.loadInventoryDetails(this.accountId, 'credit');
      this.appMainService.isHideSpinner('edit');
      this.messageService.add({ severity: "success", summary: "Success", detail: "Updated Successfully...", });
    }).catch(() => {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Error occurred while updating data...",
      });
    });
  }

  setCreditData() {
    this.credits[0].value = this.savedInventoryDetails?.creditLimit;
    const child = this.credits[0].children;
    child[0].value = this.savedInventoryDetails?.availableCredit;
    child[1].value = this.savedInventoryDetails?.usedCredit;
    this.creditForm.controls['accountCreditControlId'].setValue(this.savedInventoryDetails?.accountCreditControlId);
    this.creditForm.controls['creditTypeId'].setValue(this.savedInventoryDetails?.creditTypeId);
  }

  onTabChange(event) {
    this.selectedTabHeader = this.tabView?.tabs[this.invActiveIndex]?.header;
    switch (this.selectedTabHeader) {
      case 'Payment Method':
        this.getAccountPaymentMethods();
        this.getAllCountry();
        this.loadPaymentMethods();
        break;
      case 'Payment Term':
        this.loadPaymentTerms();
        break;
      case 'Credit Limit':
        this.setCreditData();
        break;
      case 'Address':
        this.overViewPage = true;
        this.loadCountries();
        this.loadAddressTypes();
        this.loadAccountAddressClass();
        this.sharedDataService.dispatchGettingCountriesList();
        break;
      case 'Pricing':
        this.loadPriceBookDetails(this.accountId);
        this.loadAllWareHouses();
        this.loadInventoryGroups();
        break;
      case 'Sub Accounts':
        this.loadChildAccounts();
        break
      default:
      // code block
    }
  }

  openInventoryDialog() {
    const tabHeader = this.tabView.tabs[this.invActiveIndex].header;
    this.displayAccountDetails = true;
    switch (tabHeader) {
      case 'Payment Method':
        this.isPaymentMethod = true;
        this.isShipping = false;
        this.isPaymentTerm = false
        break;
      case 'Payment Term':
        this.isPaymentTerm = true;
        this.isPaymentMethod = false;
        this.isShipping = false;
        break;
      default:
        this.isShipping = true;
        this.isPaymentMethod = false;
        this.isPaymentTerm = false;
        this.loadShippingMethods();
        this.loadShippingTerms();
        this.loadFOBPoints();
        break;
    }

  }

  getAccountPaymentMethods() {
    this.accountService.loadAccountPaymentMethods(this.accountId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.accountPaymentMethodLists = data;
      })
  }

  deletePayMethod(childMethod, parentMethod) {
    const action = childMethod.isParent ? 'remove' : 'delete';
    this.confirmationService.confirm({
      message: `Do you want to ${action} this payment method?`,
      header: "Remove Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        const accountId = childMethod.isParent ? this.accountId : null;
        this.accountService
          .deleteAccountPaymentMethod(childMethod?.id, accountId)
          .then(() => {
            const index = parentMethod.accountPaymentMethodSubDetail.indexOf(childMethod);
            parentMethod.accountPaymentMethodSubDetail?.splice(index, 1)
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: "Deleted Successfully...",
            });
          })
          .catch(() => {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Error occurred while deleting data...",
            });
          });
      },
      reject: () => { },
    });
  }

  showRelationship(payDetailId): void {
    this.appMainService.isShowSpinner('getAccessRelation');
    this.payDetailId = payDetailId;
    this.accountService.getAccountPayMethodRelation(this.accountId, payDetailId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.childAccountRelations = response;
          this.displayRelationship = true;
          this.appMainService.isHideSpinner('getAccessRelation');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getAccessRelation');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message ? error?.error?.Message : 'Relationships are not loaded...'
          });

        }
      });
  }

  onRelationClose() {
    this.displayRelationship = false;
  }

  saveRelation(data) {
    const req = {
      accountId: this.accountId,
      childAccountIds: data,
      accountSubDetailId: this.payDetailId
    }
    this.appMainService.isShowSpinner('saveRelationship');
    this.accountService.saveAccountPayMethodRelation(req)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.displayRelationship = false;
          this.appMainService.isHideSpinner('saveRelationship');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('saveRelationship');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message ? error?.error?.Message : 'Relationships are not updated, please try again later...'
          });

        }
      });

  }

  preparePayMethodForm() {
    this.accountPaymethodForm = this.fb.group({
      id: [0],
      accountPaymentMethodId: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: [''],
      paymentMethodId: [null, [Validators.required]],
      bankName: [''],
      accountName: [''],
      accountNo: [''],
      routingNo: [''],
      streetAddress1: [''],
      streetAddress2: [''],
      cityId: [null],
      stateId: [null],
      countryId: [null],
      zipCode: [''],
      accountKey: [''],
      routingKey: [''],
      statusId: [true],
      isDefault: [false],
      expirationDate: [null],
      cvv: [''],
      phoneNumber: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]]
    });
  }

  creditCardType(cc: string) {
    if (this.accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'Credit Card' && cc?.length >= 12) {
      let amex = new RegExp('^3[47][0-9]{13}$');
      let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
      let cup1 = new RegExp('^62[0-9]{14}[0-9]*$');
      let cup2 = new RegExp('^81[0-9]{14}[0-9]*$');

      let mastercard = new RegExp('^5[1-5][0-9]{14}$');
      let mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

      let disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
      let disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
      let disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');

      let diners = new RegExp('^3[0689][0-9]{12}[0-9]*$');
      let jcb = new RegExp('^35[0-9]{14}[0-9]*$');

      if (visa.test(cc)) {
        return 'VISA';
      } else if (amex.test(cc)) {
        return 'AMEX';
      } else if (mastercard.test(cc) || mastercard2.test(cc)) {
        return 'MASTERCARD';
      } else if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
        return 'DISCOVER';
      } else if (diners.test(cc)) {
        return 'DINERS';
      } else if (jcb.test(cc)) {
        return 'JCB';
      } else if (cup1.test(cc) || cup2.test(cc)) {
        return 'CHINA_UNION_PAY';
      } else {
        return undefined;
      }
    }
  }


  prepareCreditForm() {
    this.creditForm = this.fb.group({
      accountPaymentTerms: [null],
      accountPaymentMethods: [null],
      accountShippingMethods: [null],
      accountShippingTerms: [null],
      creditLimit: [0, [Validators.required]],
      dailyMax: [0],
      weeklyMax: [0],
      monthlyMax: [0],
      accountCreditEnabled: [false],
      accountCreditControlId: [this.creditOptions[0]?.code],
      creditTypeId: [this.creditTypeStatic.IndividualCredit]
    });
  }

  setDynamicFormValidation(payMethodValue) {
    if (payMethodValue.type?.name == 'ACH') {
      this.accountPaymethodForm.controls['bankName'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      this.accountPaymethodForm.controls['accountName'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      this.accountPaymethodForm.controls['accountNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      this.accountPaymethodForm.controls['expirationDate'].clearValidators();
      this.accountPaymethodForm.get('expirationDate')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['cvv'].clearValidators();
      this.accountPaymethodForm.get('cvv')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['name'].clearValidators();
      this.accountPaymethodForm.get('name')?.updateValueAndValidity();
    } else if (payMethodValue.type?.name == 'Credit Card') {
      this.accountPaymethodForm.controls['accountName'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      this.accountPaymethodForm.controls['accountNo'].setValidators(Validators.required);
      this.accountPaymethodForm.controls['expirationDate'].setValidators(Validators.required);
      this.accountPaymethodForm.controls['cvv'].setValidators(Validators.required);
      this.accountPaymethodForm.controls['bankName'].clearValidators();
      this.accountPaymethodForm.get('bankName')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['name'].clearValidators();
      this.accountPaymethodForm.get('name')?.updateValueAndValidity();
    } else {
      this.accountPaymethodForm.controls['name'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      this.accountPaymethodForm.get('name')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['bankName'].clearValidators();
      this.accountPaymethodForm.get('bankName')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['accountName'].clearValidators();
      this.accountPaymethodForm.get('accountName')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['accountNo'].clearValidators();
      this.accountPaymethodForm.get('accountNo')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['expirationDate'].clearValidators();
      this.accountPaymethodForm.get('expirationDate')?.updateValueAndValidity();
      this.accountPaymethodForm.controls['cvv'].clearValidators();
      this.accountPaymethodForm.get('cvv')?.updateValueAndValidity();
    }
    this.accountPaymethodForm.controls['name'].setValue(null);
    this.accountPaymethodForm.controls['accountName'].setValue(null);
    this.accountPaymethodForm.controls['accountNo'].setValue(null);
    this.accountPaymethodForm.controls['bankName'].setValue(null);
    this.accountPaymethodForm.controls['expirationDate'].setValue(null);
    this.accountPaymethodForm.controls['cvv'].setValue(null);
    this.accountPaymethodForm.controls['stateId'].setValue(null);
    this.accountPaymethodForm.controls['cityId'].setValue(null);
    this.accountPaymethodForm.controls['countryId'].setValue(null);
    this.accountPaymethodForm.controls['zipCode'].setValue(null);
    this.addressInput = '';
    this.accountPaymethodForm.controls['streetAddress2'].setValue(null);
  }

  removeAddressLocation() {
    this.addressInput = "";
    this.accountPaymethodForm.controls['streetAddress2'].setValue('');
    this.accountPaymethodForm.controls['countryId'].setValue(null);
    this.accountPaymethodForm.controls['stateId'].setValue(null);
    this.accountPaymethodForm.controls['cityId'].setValue(null);
    this.accountPaymethodForm.controls['zipCode'].setValue('');
  }

  getAddressObj(address) {
    const addressObj = {
      street_number: null,
      subpremise: null,
      plus_code: null,
      neighborhood: null,
      landmark: null,
      route: null,
      sublocality_level_3: null,
      sublocality_level_2: null,
      sublocality_level_1: null,
      locality: null,
      city: null,
      state: null,
      country: null,
      zipCode: null,
      latitude: address.geometry.location.lat(),
      longitude: address.geometry.location.lng(),
    }
    address.address_components.forEach(comp => {
      const field = comp.types[0];
      if (field == 'street_number') {
        addressObj.street_number = comp;
      }
      if (field == 'plus_code') {
        addressObj.plus_code = comp;
      }
      if (field == 'neighborhood') {
        addressObj.neighborhood = comp;
      }
      if (field == 'landmark') {
        addressObj.landmark = comp;
      }
      if (field == 'route') {
        addressObj.route = comp;
      }
      if (field == 'sublocality_level_3') {
        addressObj.sublocality_level_3 = comp;
      }
      if (field == 'sublocality_level_2') {
        addressObj.sublocality_level_2 = comp;
      }
      if (field == 'sublocality_level_1') {
        addressObj.sublocality_level_1 = comp;
      }
      if (field == 'subpremise') {
        addressObj.subpremise = comp;
      }
      // city
      if (field == 'locality') {
        addressObj.locality = comp;
        addressObj.city = comp;
      }
      // // city
      // if(field =='administrative_area_level_2'){
      //     addressObj.city = comp;
      // }
      // state
      if (field == 'administrative_area_level_1') {
        addressObj.state = comp;
      }

      if (field == 'country') {
        addressObj.country = comp;
      }
      if (field == 'postal_code') {
        addressObj.zipCode = comp;
      }
    });
    if (addressObj.city == null) {
      addressObj.city = addressObj.sublocality_level_1;
    }
    return addressObj;
  }

  onAddressBlur(address) {
    this.addressInput = address;
    this.formattedAddress = this.addressInput;
    if (address == '') {
      this.addressInput = '';
      this.formattedAddress = '';
      this.accountPaymethodForm.controls['streetAddress2'].setValue('');
      this.accountPaymethodForm.controls['countryId'].setValue(null);
      this.accountPaymethodForm.controls['stateId'].setValue(null);
      this.accountPaymethodForm.controls['cityId'].setValue(null);
      this.accountPaymethodForm.controls['zipCode'].setValue('');
    }
  }

  getStreetAddres(googleAddressObj) {
    const street = [];
    if (googleAddressObj.plus_code) {
      street.push(googleAddressObj.plus_code.long_name);
    }
    if (googleAddressObj.street_number) {
      street.push(googleAddressObj.street_number.long_name);
    }
    if (googleAddressObj.route) {
      street.push(googleAddressObj.route.long_name);
    }
    if (googleAddressObj.subpremise) {
      street.push(`#${googleAddressObj.subpremise.long_name}`);
    }
    if (googleAddressObj.neighborhood) {
      street.push(googleAddressObj.neighborhood.long_name);
    }
    if (googleAddressObj.sublocality_level_3) {
      street.push(googleAddressObj.sublocality_level_3.long_name);
    }
    if (googleAddressObj.sublocality_level_2) {
      street.push(googleAddressObj.sublocality_level_2.long_name);
    }
    if (googleAddressObj.sublocality_level_1 && googleAddressObj.locality != null) {
      street.push(googleAddressObj.sublocality_level_1.long_name);
    }
    // if(googleAddressObj.locality){
    //     street.push(googleAddressObj.locality.long_name);
    // }
    return street.length ? street.join(' ') : '';
  }

  async locationAddresChanged(address: any) {
    this.removeAddressLocation();
    //setting address from API to local variable
    this.ErrorMessageSetLocation = "";
    //var fullAddress = address.address_components;
    this.formattedAddress = address.formatted_address;
    const googleAddressObj = this.getAddressObj(address);
    //   const addressArr = address.formatted_address.split(",");
    //   const len = addressArr.length;
    //   const addressName = len > 2 ? addressArr.slice(0, len - 3).join() : "";
    setTimeout(() => {
      //   this.addressInput = addressName;
      const da = this.getStreetAddres(googleAddressObj); //updatedAddressLine;
      this.addressInput = da;
      this.formattedAddress = da;
    });

    this.accountPaymethodForm.controls['countryId'].setValue(null);
    this.accountPaymethodForm.controls['stateId'].setValue(null);
    this.accountPaymethodForm.controls['cityId'].setValue(null);
    this.accountPaymethodForm.controls['zipCode'].setValue('');

    let searchedCountry = googleAddressObj.country ? googleAddressObj.country.long_name : '';
    let searchedZipcode = googleAddressObj.zipCode ? googleAddressObj.zipCode.long_name : '';
    let searchedState = googleAddressObj.state ? googleAddressObj.state.long_name : '';
    let searchedCity = googleAddressObj.city ? googleAddressObj.city.long_name : '';
    if (searchedCountry) {
      let matchedCountry;
      if (searchedCountry == 'USA' || searchedCountry == 'United States') {
        matchedCountry = this.country.find(obj => obj.name == searchedCountry || obj.countryCode == googleAddressObj.country.short_name);
      } else {
        matchedCountry = this.country.find(obj => obj.name == searchedCountry)
      }

      if (matchedCountry) {
        await this.getAsyncStatesFromCountry(matchedCountry?.id);
        this.accountPaymethodForm.controls['countryId'].setValue(matchedCountry);
        //set state
        let matchedState = this.states.find(obj => obj.name == searchedState || obj.shortName == googleAddressObj.state.short_name);
        if (matchedState) {
          //await this.getAsyncCitiesFromState(matchedState);
          this.accountPaymethodForm.controls['stateId'].setValue(matchedState);
        } else if (!matchedState) {
          // add state
          matchedState = await this.addState(googleAddressObj.state, matchedCountry.id);
          this.accountPaymethodForm.controls['stateId'].setValue(matchedState);
        }

        await this.getAsyncCitiesFromState(matchedState?.id);

        if (searchedZipcode) {
          this.accountPaymethodForm.controls['zipCode'].setValue(searchedZipcode);
        }
        //set city
        let matchedCity = this.city ? this.city.find(obj => obj.name == searchedCity) : null;
        if (matchedCity) {
          this.accountPaymethodForm.controls['cityId'].setValue(matchedCity);
        } else if (!matchedCity) {
          matchedCity = await this.addCity(searchedCity, matchedState.id);
          this.accountPaymethodForm.controls['cityId'].setValue(matchedCity);
        }
      }
    }
  }

  getAllCountry() {
    this.accountService.getCountry().subscribe((country) => {
      this.country = country;
    });
  }

  async getAsyncStatesFromCountry(countryId) {
    await this.accountService.getAllStates(countryId).then((states) => {
      this.states = states;
      this.accountPaymethodForm.controls['stateId'].setValue(null)
    });
  }

  async getAsyncCitiesFromState(stateId) {
    await this.accountService.getAllCities(stateId).then((cities) => {
      this.city = cities;
      this.accountPaymethodForm.controls['cityId'].setValue(null);
    });
  }

  async addCity(searchedCityName, stateId) {
    const data = {
      id: 0,
      createdSource: this.app.user.userIP,
      updatedSource: null,
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: null,
      name: searchedCityName,
      description: searchedCityName,
      stateId: stateId,
      statusId: 1,
    }
    const newAddedCity = await this.accountService.addCity(data)
    this.city = addInList(this.city, newAddedCity);
    return newAddedCity;
  }


  async addState(stateDetails, countryId) {
    const data = {
      id: 0,
      createdSource: this.app.user.userIP,
      updatedSource: null,
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: null,
      name: stateDetails.long_name,
      shortName: stateDetails.short_name,
      description: stateDetails.long_name,
      countryId: countryId,
      statusId: 1,
    }
    const newAddedState = await this.accountService.addState(data);
    this.states = addInList(this.states, newAddedState);
    return newAddedState;
  }

  loadCountries(): void {
    this.sharedDataService
      .loadCountries()
      .pipe(
        map((countries) => {
          this.countries = countries || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAddressTypes() {
    this.accountService.getAccounAddressTypes().subscribe(addressTypes => {
      this.addressTypes = addressTypes;
    });
  }

  loadAccountAddressClass() {
    this.accountService.getAccountAddressClasses().subscribe(addressClasses => {
      this.addressClasses = addressClasses;
    });
  }

  onUpdateAddressList(event) {
    this.selectedAccount.accountAddresses = event?.addressList;
  }

  cancelShippingMethod() {
    this.displayAccountDetails = false;
  }

  loadChildAccounts() {
    if (this.selectedAccount?.hasChildAccounts && this.savedDetailViewCols?.length > 0) {

      const selectableColumns: any[] = [];
      if (this.savedDetailViewCols.length > 0) {
        this.savedDetailViewCols.forEach((obj) => {
          if (obj.enabled) {
            selectableColumns.push(
              {
                columnName: obj.columnName,
                isCustom: obj.isCustom
              }
            )
          }
        });
      }

      const requestModel: GelAllAccountRequestModel = {
        channelId: this.selectedAccount?.typeId,
        stageId: null,
        isActive: !!(this.selectedAccount?.statusId == 1),
        globalSearchValue: '',
        selectableColumns: selectableColumns,
        filter: '',
        pageSize: 0,
        pageNumber: 0,
        sortByColumn: '',
        isSortByDescending: false,
        filterInColumns: [],
        parentAccountId: this.selectedAccount.id
      }

      this.appMainService.isShowSpinner('getAccountByParentId');
      this.accountServiceN.getAccountsList(requestModel)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response) => {
            if (response) {
              this.childAccounts = response?.list || [];
              this.totalChildRecords = this.childAccounts?.length || 0;
            }
            this.appMainService.isHideSpinner('getAccountByParentId');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getAccountByParentId');
            this.messageService.add({
              severity: 'error',
              summary: 'Error!',
              detail: 'Error occurring when loading accounts. Please try after sometime.'
            });
          },
          complete: () => {

          }
        })

    }
  }

  onChildAccountSelect() {
    this.openAccountViewEdit(this.selectedChildAccount?.id);
  }

  openAccountViewEdit(accountId: number) {
    this.displayAccountViewEdit = true;
    this.selectedAccountId = accountId;
  }

  closeAccountViewEditModal() {
    this.displayAccountViewEdit = false;
    this.selectedAccountId = 0;
  }

  selectSubTab(index: number) {
    this.activeSubtabIndex = index;
  }

  deleteSublist(sublistDetails: DynamicTableWidgetDetailsM) {
    this.deleteSubtab.emit(sublistDetails)
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
